<template>
  <div>
    <div class="d-flex align-items-start" v-if="!editStatus">
      <img :src="item.user.picture" class="mr-3 rounded-circle" width="48" height="48" alt />
      <div class="w-100">
        <h6 class="font-weight-normal my-0">{{ item.user.full_name }}</h6>
        <small class="text-muted">{{ item.created_at.datetime }}</small>
        <p class="text-gray mt-3" v-html="item.content"></p>
        <div class="d-flex justify-content-between">
          <div>
            <a href="#" class="d-inline-block mr-4 text-decoration-none"
              @click.prevent="likeComment(item, item.id)">
              <template>
                <i v-if="item.isLike" class="material-icons text-primary">favorite</i>
                <i v-else class="material-icons text-secondary">favorite_border</i>
              </template>
              <span class="badge">
                {{ item.options.likes && item.options.likes.length > 0 ?
                  item.options.likes.length : '' }}
              </span>
            </a>

            <div class="d-inline-block text-decoration-none" v-if="type == 1">
              <template>
                <i v-if="item.reply.length" class="material-icons text-dark">chat_bubble</i>
                <i v-else class="material-icons text-dark">chat_bubble_outline</i>
              </template>
              <span class="badge">{{ item.reply.length ? item.reply.length : ''}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-group dropleft" v-if="userId == item.user.id || adminAuth == '1'">
        <a href="#" class="text-dark" @click.prevent="dropdownShow(item.id)">
          <span class="material-icons">
            more_vert
          </span>
        </a>
        <div class="dropdown-menu" :class="{'show': item.id == dropdownID}">
          <a class="dropdown-item" href="#" v-if="userId == item.user.id"
            @click.prevent="editComment(true)">編輯</a>
          <a class="dropdown-item" href="#" @click.prevent="openDeleteModal(item.id, type)">刪除</a>
        </div>
      </div>
    </div>
    <div class="input-group flex-nowrap mt-1" v-else>
      <!-- @keyup="autogrow($event)" -->
        <textarea rows="1" ref="commentTextarea"
          v-model="editCacheComment"
          type="text"
          class="form-control bg-light py-2"
          placeholder="新增留言..."
          aria-label="Username"
          aria-describedby="addon-wrapping"
          @keyup.esc="editComment(false)"
          @focus="autogrow($event)"
          @keydown="autogrow($event)"
        />
        <div class="input-group-prepend">
          <button
            class="input-group-text btn bg-light rounded-right"
            id="addon-wrapping"
            @click="submitForm(item.id, editCacheComment)"
          >
            <div class="spinner-grow spinner-grow-sm" role="status"
              v-if="isLoading.send || loading">
              <span class="sr-only">Loading...</span>
            </div>
            <i class="material-icons" v-else>send</i>
          </button>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    type: Number,
    userId: String,
    loading: Boolean,
    adminAuth: String, // 確認是否有 Admin 權限（可刪除所有人的留言）
    postName: String,
  },
  data() {
    return {
      dropdownID: -1,
      editStatus: false,
      editCacheComment: '',
      isLoading: {
        send: false,
      },
    };
  },
  methods: {
    deleteComment() {
      axios.delete(`/api/comment/${this.deleteID}`).then((res) => {
        if (res.status == 200) {
          this.getData(1);
          this.deleteID = '';
        }
      });
    },
    editComment(status) {
      this.editStatus = status;
      this.dropdownID = -1;
      this.editCacheComment = this.item.content.replace(/<br>/g, '\n');
    },
    dropdownShow(id) {
      this.dropdownID == id ? this.dropdownID = -1 : this.dropdownID = id;
    },
    likeComment(item, id) {
      const vm = this;
      let url = `/api/comment/${id}/like`;
      if (item.isLike) {
        url = `/api/comment/${id}/unlike`;
      }
      axios
        .get(url)
        .then((res) => {
          if (!item.isLike) {
            if (!item.options.hasOwnProperty('likes')) { item.options.likes = []; }
            item.options.likes.push(parseInt(vm.userId));
          } else {
            const index = item.options.likes.indexOf(parseInt(vm.userId));
            if (index > -1) {
              item.options.likes.splice(index, 1);
            }
          }
          item.isLike = !item.isLike;
          if (item.isLike) {
            vm.gaTrackEvent('Comment', 'Like', vm.postName);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openDeleteModal(id, type) {
      this.$emit('openDeleteModal', id, type);
    },
    autogrow(e) {
      setTimeout(() => {
        e.target.style.cssText = 'height:auto; padding:0';
        e.target.style.cssText = `height:${e.target.scrollHeight}px`;
      }, 0);
    },
    submitForm(id, content) {
      const vm = this;
      vm.isLoading.send = true;
      axios.patch(`/api/comment/${id}`, { content: content.replace(/\n/g, '<br>') }).then((res) => {
        if (res.status == 200) {
          this.$emit('update', id, this.type, res.data.data);
          this.editStatus = false;
          this.editCacheComment = '';
          vm.isLoading.send = false;
        }
      });
    },
  },
  mounted() {
    this.$set(this.item, 'isLike', this.item.isLike);
  },
};
</script>
